// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu {
  display: flex;
  flex-direction: column;
}

.account {
  transform: scale(2);
}

.place-data {
  margin: 15px;
  max-width: 320px;
  display: grid;
}

.list {
  max-width: 320px;
}

.text-left {
  text-align: left;
}

.button-selector {
  background: transparent;
  border: solid 1px black;
  margin: 5px 0px;
  transition: all 0.3s ease-in-out;
}
.button-selector:hover {
  background-color: antiquewhite;
  color: rgb(28, 27, 27);
}

.sidenav-footer {
  position: absolute;
  bottom: 5px;
}

@keyframes shine {
  to {
    background-position: 200% center;
  }
}
.padding-icon {
  position: relative;
  top: 5px;
  padding-right: 10px;
}

.profile {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
}
.profile .content-profile {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 50%;
  margin: 5px;
}
.profile img {
  width: 40px;
  height: 40px;
}

::ng-deep .mdc-list {
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: start !important;
  padding: 0px !important;
}

::ng-deep .mat-mdc-list-item {
  cursor: pointer !important;
  display: flex !important;
  width: 80% !important;
  height: 39px !important;
}

::ng-deep .mdc-list-item__content {
  display: flex !important;
  align-items: center !important;
}

::ng-deep .mdc-list-item__primary-text {
  color: #000000;
}

span {
  margin: 0px;
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
}

::ng-deep .mdc-list-item:focus {
  background: #ededed;
}

mat-list-option[aria-selected=true] {
  background: #ededed;
}

.button-sidebar:first-child {
  background-color: #ededed;
}

.user-button {
  position: absolute;
  bottom: -20px;
}
.user-button mat-icon {
  background-color: #d9d9d9;
  border-radius: 50%;
  padding-right: 0px;
}
.user-button .user-container {
  display: flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
}
.user-button .user-details {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-left: 10px;
}
.user-button .user-name {
  font-weight: 500;
  line-height: 16.41px;
  margin-bottom: 5px !important;
}
.user-button .user-email {
  font-weight: 300;
  line-height: 12.89px;
  height: 20px;
}
.user-button .user-name,
.user-button .user-email {
  margin: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media screen and (max-width: 1024px) {
  .user-button {
    bottom: 0;
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/basic/sidenav/sidenav.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,uBAAA;EACA,uBAAA;EACA,eAAA;EACA,gCAAA;AACF;AACE;EACE,8BAAA;EACA,sBAAA;AACJ;;AAGA;EACE,kBAAA;EACA,WAAA;AAAF;;AAGA;EACE;IACE,gCAAA;EAAF;AACF;AAGA;EACE,kBAAA;EACA,QAAA;EACA,mBAAA;AADF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;AADF;AAGE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,kBAAA;EACA,WAAA;AADJ;AAIE;EACE,WAAA;EACA,YAAA;AAFJ;;AAMA;EACE,wBAAA;EACA,iCAAA;EACA,kCAAA;EACA,8BAAA;EACA,4BAAA;EACA,uBAAA;AAHF;;AAMA;EACE,0BAAA;EACA,wBAAA;EACA,qBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,wBAAA;EACA,8BAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,yBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,aAAA;AAHF;AAKE;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;AAHJ;AAME;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAJJ;AAOE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;AALJ;AAQE;EACE,gBAAA;EACA,oBAAA;EACA,6BAAA;AANJ;AASE;EACE,gBAAA;EACA,oBAAA;EACA,YAAA;AAPJ;AAUE;;EAEE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AARJ;;AAYA;EACE;IACE,SAAA;EATF;AACF;AACA,w3KAAw3K","sourcesContent":[".menu {\n  display: flex;\n  flex-direction: column;\n}\n\n.account {\n  transform: scale(2);\n}\n\n.place-data {\n  margin: 15px;\n  max-width: 320px;\n  display: grid;\n}\n\n.list {\n  max-width: 320px;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.button-selector {\n  background: transparent;\n  border: solid 1px black;\n  margin: 5px 0px;\n  transition: all 0.3s ease-in-out;\n\n  &:hover {\n    background-color: antiquewhite;\n    color: rgb(28, 27, 27);\n  }\n}\n\n.sidenav-footer {\n  position: absolute;\n  bottom: 5px;\n}\n\n@keyframes shine {\n  to {\n    background-position: 200% center;\n  }\n}\n\n.padding-icon {\n  position: relative;\n  top: 5px;\n  padding-right: 10px;\n}\n\n.profile {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 10px;\n\n  .content-profile {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 60px;\n    height: 60px;\n    background: rgba(255, 255, 255, 0.85);\n    border-radius: 50%;\n    margin: 5px;\n  }\n\n  img {\n    width: 40px;\n    height: 40px;\n  }\n}\n\n::ng-deep .mdc-list {\n  display: flex !important;\n  flex-direction: column !important;\n  justify-content: center !important;\n  align-items: center !important;\n  text-align: start !important;\n  padding: 0px !important;\n}\n\n::ng-deep .mat-mdc-list-item {\n  cursor: pointer !important;\n  display: flex !important;\n  width: 80% !important;\n  height: 39px !important;\n}\n\n::ng-deep .mdc-list-item__content {\n  display: flex !important;\n  align-items: center !important;\n}\n\n::ng-deep .mdc-list-item__primary-text {\n  color: #000000;\n}\n\nspan {\n  margin: 0px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n::ng-deep .mdc-list-item:focus {\n  background: #ededed;\n}\n\nmat-list-option[aria-selected=\"true\"] {\n  background: #ededed;\n}\n\n.button-sidebar:first-child {\n  background-color: #ededed;\n}\n\n.user-button {\n  position: absolute;\n  bottom: -20px;\n\n  mat-icon {\n    background-color: #d9d9d9;\n    border-radius: 50%;\n    padding-right: 0px;\n  }\n\n  .user-container {\n    display: flex;\n    align-items: center;\n    overflow: hidden;\n    white-space: nowrap;\n  }\n\n  .user-details {\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    margin-left: 10px;\n  }\n\n  .user-name {\n    font-weight: 500;\n    line-height: 16.41px;\n    margin-bottom: 5px !important;\n  }\n\n  .user-email {\n    font-weight: 300;\n    line-height: 12.89px;\n    height: 20px;\n  }\n\n  .user-name,\n  .user-email {\n    margin: 0px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .user-button {\n    bottom: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
